export enum AffiliatesActionTypes {
  GET_LIST_AFFILIATES_SUCCESS = "AFFILIATES_GET_LIST_SUCCESS",
  GET_LIST_AFFILIATES_ERROR = "AFFILIATES_GET_LIST_ERROR",
  GET_LIST_AFFILIATES = "AFFILIATES_GET_LIST",
  CREATE_AFFILIATE = "CREATE_AFFILIATE",
  CREATE_AFFILIATE_SUCCESS = "CREATE_AFFILIATE_SUCCESS",
  CREATE_AFFILIATE_ERROR = "CREATE_AFFILIATE_ERROR",
  GET_AFFILIATE = "GET_AFFILIATE",
  GET_AFFILIATE_SUCCESS = "GET_AFFILIATE_SUCCESS",
  GET_AFFILIATE_ERROR = "GET_AFFILIATE_ERROR",
  UPDATE_AFFILIATE = "UPDATE_AFFILIATE",
  UPDATE_AFFILIATE_SUCCESS = "UPDATE_AFFILIATE_SUCCESS",
  UPDATE_AFFILIATE_ERROR = "UPDATE_AFFILIATE_ERROR",
  DELETE_AFFILIATE = "DELETE_AFFILIATE",
  DELETE_AFFILIATE_SUCCESS = "DELETE_AFFILIATE_SUCCESS",
  DELETE_AFFILIATE_ERROR = "DELETE_AFFILIATE_ERROR",
}
